import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getQueryStringResults } from '@plone/volto/actions';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { Spinner } from 'design-react-kit';
import {
    SearchStruttureBackgroundUser,
    SearchStruttureBackground,
    StrutturaTemplate,
} from 'uniba-volto-persone/components';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { NavLink } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';


const minCharsForDropdown = 3;
class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputText: '',
            searchedInputText: '',
            isFirstLoad: false,
            currentPage: 1,
            fineRisultati: false,
            pages: [],
            isLoadingMore: false,
            searchValue: null,
            dropdownHeight: 0,
            prevQuery: {},
        };

        this.inputRef = createRef();
        this.dropdownRef = createRef();
        this.b_size = 30;

        this.handleScroll = debounce(this.handleScroll.bind(this), 200);
    };

    parametersFromGet(location) {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("SearchableText");
    };

    setGetSearch = (search) => {
        const { history, location } = this.props;
        const queryParams = new URLSearchParams(location.search);
        queryParams.set("SearchableText", search);
        history.replace(`${location.pathname}?${queryParams.toString()}`);
    };

    handleScroll() {
        const { raw_querystringResults } = this.props;
        const {
            searchedInputText,
            searchValue,
            currentPage
        } = this.state;

        const bottom = window.innerHeight + document.documentElement.scrollTop
            >= document.documentElement.scrollHeight - 1;

        if (bottom && (searchedInputText !== "" || searchValue)) {
            if (raw_querystringResults?.total > currentPage * this.b_size) {
                this.setState(
                    (state) => (
                        { currentPage: state.currentPage + 1 }
                    )
                );
            } else {
                this.setState({ fineRisultati: true });
            }
        }
    };

    generateQuery(overrideText) {
        const { data } = this.props;
        const { inputText, searchValue } = this.state;

        const query = [
            {
                i: 'portal_type',
                o: 'plone.app.querystring.operation.selection.any',
                v: ['Struttura'],
            },
            {
                i: 'path',
                o: 'plone.app.querystring.operation.string.absolutePath',
                v: data?.path?.getPath ?? "/strutture",
            },
        ];

        let finalSearchValue = overrideText || searchValue || inputText;
        if (finalSearchValue) {
            query.push({
                i: 'SearchableText',
                o: 'plone.app.querystring.operation.string.is',
                v: finalSearchValue,
            });
        }

        return query;
    };

    doRequest(
        query,
        b_start = 0,
        b_size = this.b_size,
        id_query = '_strutture_search',
        sort_on,
        sort_order
    ) {
        const { dispatch, data, subsite, id } = this.props;

        const q = query || this.generateQuery();
        if (!q) return;
        this.setState({
            prevQuery: query
        });
        const finalSortOn = sort_on ?? data.sort_on ?? "sortable_title";
        const finalSortOrder = sort_order ??
            (data.sort_order ? 'descending' : 'ascending');
        this.setState({ isFirstLoad: false, fineRisultati: false });
        dispatch(
            getQueryStringResults(
                subsite ? flattenToAppURL(subsite['@id']) : '',
                {
                    fullobjects: 0,
                    query: q,
                    b_start,
                    b_size,
                    sort_on: finalSortOn,
                    sort_order: finalSortOrder,
                    metadata_fields: '_all',
                },
                id + id_query,
            ),
        );
    };

    componentDidMount() {
        const { location } = this.props;
        const searchValue = this.parametersFromGet(location);
        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }

        if (searchValue) {
            this.setState({ inputText: searchValue, searchValue }, () => {
                const query = this.generateQuery();
                if (!isEqual(this.state.prevQuery, query)) {
                    this.doRequest(query);
                };
            });
        } else {
            this.setState({ isFirstLoad: true });
        }

        window.addEventListener('scroll', this.handleScroll);
    };

    componentDidUpdate(prevProps, prevState) {
        const {
            location,
            raw_querystringResults,
            raw_qss_subrequests
        } = this.props;

        const {
            searchValue,
            currentPage,
            searchedInputText,
            pages
        } = this.state;

        const dynamicKey = this.props.id + '_strutture_search_' + currentPage;
        const additional_items =
            raw_qss_subrequests?.[dynamicKey]?.items;

        const additional_loading =
            raw_qss_subrequests?.[dynamicKey]?.loading || false;

        const prev_additional_items =
            prevProps.raw_qss_subrequests?.[dynamicKey]?.items;

        const prev_additional_loading =
            prevProps.raw_qss_subrequests?.[dynamicKey]?.loading || false;

        // Al cambio dell'URL, cambio inputText e searchValue 
        // ed eseguo la richiesta
        if (location.search !== prevProps.location.search) {
            const newSearchValue = this.parametersFromGet(location);
            this.setState({
                searchValue: newSearchValue,
                inputText: newSearchValue
            });
            if (newSearchValue === "") {
                this.setState({ isFirstLoad: true });
            } else {
                const query = this.generateQuery(newSearchValue);
                if (!isEqual(this.state.prevQuery, query)) {
                    this.doRequest(query);
                };
            }
        }

        // Al cambio della currentPage (e non è la prima), 
        // eseguo una query aggiuntiva
        if (currentPage !== prevState.currentPage && currentPage !== 1) {
            const bstart = (currentPage - 1) * this.b_size;
            this.doRequest(
                undefined,
                bstart,
                this.b_size,
                '_strutture_search_' + currentPage
            );
        }

        // Al cambio dei risultati aggiuntivi
        if (
            additional_items !== undefined &&
            additional_items !== prev_additional_items
        ) {
            // Se non sta caricando e i risultati aggiuntivi sono presenti
            if (!additional_loading && additional_items.length > 0) {
                this.setState({
                    isLoadingMore: false,
                    pages: [...pages, additional_items],
                    fineRisultati: additional_items.length < this.b_size,
                });
            }

            // Se non sta caricando e i risultati aggiuntivi NON sono presenti
            if (
                !additional_loading &&
                Array.isArray(additional_items) &&
                additional_items?.length === 0 &&
                searchedInputText !== ""
            ) {
                this.setState({
                    isLoadingMore: false,
                    fineRisultati: true,
                });
            }
        }

        // Quando carico risultati aggiuntivi, vado in stato "loading"
        if (additional_loading && !prev_additional_loading) {
            this.setState({
                isLoadingMore: true,
                fineRisultati: false,
            });
        }

        // Effettuata la ricerca, se i risultati sono minori 
        // del massimo numero di risultati per quella pagina,
        // imposto la scritta "Fine dei risultati"
        if (
            (searchedInputText !== '' || searchValue) &&
            raw_querystringResults &&
            !raw_querystringResults.loading &&
            raw_querystringResults.loaded &&
            raw_querystringResults?.total < currentPage * this.b_size &&
            !this.state.fineRisultati
        ) {
            this.setState({ fineRisultati: true });
        }

        // Calcolo l'altezza del dropdown se è visibile
        if (
            this.state.inputText?.length >= minCharsForDropdown &&
            this.dropdownRef.current
        ) {
            requestAnimationFrame(() => {
                const el = this.dropdownRef?.current?.ref?.current?.children[0];
                if (el) {
                    const height = el.offsetHeight;
                    if (height !== this.state.dropdownHeight) {
                        this.setState({ dropdownHeight: height });
                    }
                }
            });
        }

        // Al cambio dell inputText, se diventa con più di minCharsForDropdown 
        // caratteri, effettuo una ricerca e scrivo i risultati del dropdown
        if (
            prevState.inputText !== this.state.inputText &&
            this.state.inputText?.length >= minCharsForDropdown
        ) {
            const query = this.generateQuery(this.state.inputText);
            if (!isEqual(this.state.prevQuery, query)) {
                this.doRequest(query);
            }
            this.setState({ clearResults: false });
        }
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    render() {
        const {
            intl,
            data,
            raw_items,
            loading,
            content,
            raw_querystringResults
        } = this.props;

        const {
            inputText = '',
            fineRisultati,
            pages,
            isLoadingMore,
            isFirstLoad,
            searchedInputText,
            searchValue,
            dropdownHeight
        } = this.state;

        const items =
            isFirstLoad && content
                ? content.items
                : raw_items;

        const intl_doSearch = intl.formatMessage({ id: 'doSearch' });

        const totalResults = raw_querystringResults?.total ?? 0;
        const showNResults = raw_querystringResults?.total !== undefined &&
            !isFirstLoad;
        return (
            <div className="public-ui searchStrutture">
                {data?.image ?
                    <SearchStruttureBackgroundUser image={data.image} />
                    :
                    <SearchStruttureBackground />
                }
                <div className="ui container">
                    {/* Input e risultati */}
                    <div
                        className="searchContainer 
                            d-flex w-100 mt-5 flex-column"
                    >
                        <h3 className="search-strutture-title text-primary">
                            {intl.formatMessage(
                                { id: 'strutture_doSearchHeader' }
                            )}
                        </h3>

                        <div className="searchbar shadow-sm d-flex w-100">
                            <button
                                className="rounded-start"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setGetSearch(inputText);
                                    this.setState({
                                        currentPage: 1,
                                        pages: [],
                                        searchedInputText: inputText,
                                    });
                                }}
                                aria-label={intl_doSearch}
                                title={intl_doSearch}
                            >
                                <Icon
                                    icon="it-search"
                                    padding={false}
                                    size="md"
                                    aria-hidden="true"
                                />
                            </button>
                            <label
                                htmlFor="searchInput"
                                className="visually-hidden"
                            >
                                {intl.formatMessage(
                                    { id: 'searchInStrutture' }
                                )}
                            </label>
                            <input
                                className="inputSearch"
                                ref={this.inputRef}
                                type="search"
                                value={inputText}
                                autoComplete="off"
                                onChange={(e) => {
                                    this.setState(
                                        { inputText: e.target.value }
                                    );
                                    this.props.onSearchInputChange?.(e.target.value);
                                }
                                }
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        this.setGetSearch(inputText);
                                        this.setState({
                                            currentPage: 1,
                                            pages: [],
                                            searchedInputText: inputText,
                                        });
                                    }
                                }}
                                placeholder={intl.formatMessage(
                                    { id: 'strutture_doSearchHelper' }
                                )}
                                aria-label={intl.formatMessage(
                                    { id: 'strutture_doSearchAria' }
                                )}
                                title={intl.formatMessage(
                                    { id: 'doSearchTitle' }
                                )}
                            />
                        </div>
                        <Dropdown
                            open={inputText?.length >= minCharsForDropdown}
                            upward={false}
                            trigger={<></>}
                            className="dropdown-risultati mt-0"
                            icon={null}
                            ref={this.dropdownRef}
                            id="searchInput-dropdownResults"
                            tabIndex={-1}
                        >
                            <DropdownMenu>
                                {items.length > 0 ? (
                                    items.map((item) => (
                                        <DropdownItem
                                            key={item['@id']}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    const link = e.currentTarget.querySelector('a');
                                                    if (link) link.click();
                                                }
                                            }}
                                            onClick={(e) => {
                                                if (e.target.tagName.toLowerCase() !== 'a') {
                                                    const link = e.currentTarget.querySelector('a');
                                                    if (link) link.click();
                                                }
                                            }}
                                        >
                                            <NavLink to={item['@id']}>
                                                {item.Title} ({item.parent?.title})
                                            </NavLink>
                                        </DropdownItem>
                                    ))
                                ) : (
                                    <DropdownItem disabled>
                                        {intl.formatMessage({ id: 'noResult' })}
                                    </DropdownItem>
                                )}
                            </DropdownMenu>
                        </Dropdown>
                        <div
                            style={{
                                height: inputText?.length >= minCharsForDropdown ? `${dropdownHeight}px` : '0px',
                                transition: 'height 300ms ease',
                                overflow: 'hidden',
                            }}
                        />
                    </div>
                    {/* Testo Helper "Risultati per: " */}
                    {(searchedInputText || searchValue) && (
                        <h5 className="resultSearchDescription mt-3">
                            {intl.formatMessage({ id: 'resultsLabel' })}
                            {searchedInputText || searchValue ? (
                                <>
                                    {' '}
                                    {intl.formatMessage(
                                        { id: 'resultsLabel3' }
                                    )}
                                    {' '}
                                    <b
                                        className="text-muted 
                                            highlightedSearchTerm"
                                    >
                                        {searchedInputText || searchValue}
                                    </b>
                                </>
                            ) : null}
                        </h5>
                    )}
                    {/* Testo Helper "X risultati" */}
                    {showNResults ? (
                        <>
                            <hr />
                            <h5>
                                <b>
                                    {totalResults}
                                </b>
                                {' '}
                                {intl.formatMessage({ id: 'resultsLabel2' })}
                            </h5>
                        </>
                    ) : null}
                    {/* Risultati */}
                    {!loading ? (
                        items.length > 0 ? (
                            <div className="mt-4" aria-live="polite">
                                <div className="block listing">
                                    <StrutturaTemplate
                                        items={items}
                                        full_width={true}
                                        page={1}
                                    />
                                    {pages.map((pageItems, index) => (
                                        <StrutturaTemplate
                                            key={`page-${index + 2}`}
                                            items={pageItems}
                                            full_width={true}
                                            page={index + 2}
                                        />
                                    ))}
                                    {isLoadingMore && (
                                        <div
                                            className="d-flex 
                                                justify-content-center mt-3">
                                            <Spinner active />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : null
                    ) : (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner active />
                        </div>
                    )}
                    {/* Messaggio fine Risultati */}
                    {fineRisultati && (
                        <div className="mt-4" aria-live="polite">
                            <h5 className="text-center">
                                {intl.formatMessage(
                                    { id: 'strutture_endResult' }
                                )}
                            </h5>
                        </div>
                    )}
                </div>
            </div>
        );
    };
}

Body.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    content: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    raw_querystringResults: PropTypes.object,
    raw_qss_subrequests: PropTypes.object,
    raw_items: PropTypes.array,
    loading: PropTypes.bool,
    subsite: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => (
    {
        raw_querystringResults:
            state.
                querystringsearch?.
                subrequests?.
            [ownProps.id + '_strutture_search'],

        raw_qss_subrequests:
            state.
                querystringsearch?.
                subrequests,

        raw_items:
            state.
                querystringsearch?.
                subrequests?.
            [ownProps.id + '_strutture_search']?.items || [],

        loading:
            state.
                querystringsearch?.
                subrequests?.
            [ownProps.id + '_strutture_search']?.loading || false,

        subsite:
            state.subsite?.data,
    }
);

export default connect(mapStateToProps)(
    injectIntl(withRouter(Body)),
);
